import React, { useState, useEffect } from "react";

import Grid from "@material-ui/core/Grid";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import Select from "@material-ui/core/Select";

import DateFnsUtils from "@date-io/date-fns";
import {
    MuiPickersUtilsProvider,
    KeyboardDatePicker,
} from "@material-ui/pickers";


const DatesSelector = ({ dateLastDay, onUpdateDateRanges }) => {
    const [dateRangeType, setDateRangeType] = useState("last-day");
    const [fromDate, setFromDate] = useState(dateLastDay);
    const [toDate, setToDate] = useState(dateLastDay);

    useEffect(() => {
        setDates();
    }, [dateLastDay, dateRangeType]);

    function handleFromDateChange(newFromDate) {
        onUpdateDateRanges(newFromDate, toDate);
        setFromDate(newFromDate);
    }

    function handleToDateChange(newToDate) {
        onUpdateDateRanges(fromDate, newToDate);
        setToDate(newToDate);
    }

    const handleChangeDates = (event) => {
        let dateRangeType = event.target.value;
        setDateRangeType(dateRangeType);
        setDates();
    };

    function setDates() {
        let dateLastWeek = new Date(
            dateLastDay.getFullYear(),
            dateLastDay.getMonth(),
            dateLastDay.getDate() - 7
        );
        let dateLastMonth = new Date(
            dateLastDay.getFullYear(),
            dateLastDay.getMonth(),
            dateLastDay.getDate() - 30
        );

        let newFromDate = dateLastDay;
        let newToDate = dateLastDay;

        switch (dateRangeType) {
            case "last-day":
                break;
            case "last-week":
                newFromDate = dateLastWeek;
                break;
            case "last-month":
                newFromDate = dateLastMonth;
                break;
            case "custom":
                newFromDate = fromDate;
                break;
            default:
                break;
        }
        setToDate(newToDate);
        setFromDate(newFromDate);
        onUpdateDateRanges(newFromDate, newToDate);
    }

    return (
        <>
            <Grid container spacing={1}>
                <Grid item xs={3}>
                    <InputLabel id="select-dates">Dates</InputLabel>
                    <Select
                        labelId="selectDates"
                        id="select-date"
                        defaultValue={"last-day"}
                        onChange={handleChangeDates}
                    >
                        <MenuItem value={"last-day"}>Last Day</MenuItem>
                        <MenuItem value={"last-week"}>Last Week</MenuItem>
                        <MenuItem value={"last-month"}>Last Month</MenuItem>
                        <MenuItem value={"custom"}>Custom Range</MenuItem>
                    </Select>
                </Grid>
                <Grid item xs={3}>
                    <MuiPickersUtilsProvider utils={DateFnsUtils}>
                        <KeyboardDatePicker
                            disableToolbar
                            disabled={dateRangeType !== "custom"}
                            variant="inline"
                            format="MM/dd/yyyy"
                            margin="normal"
                            id="from-date-picker"
                            label=""
                            value={fromDate}
                            onChange={handleFromDateChange}
                            KeyboardButtonProps={{
                                "aria-label": "change date",
                            }}
                        />
                    </MuiPickersUtilsProvider>
                </Grid>
                <Grid item xs={3}>
                    <MuiPickersUtilsProvider utils={DateFnsUtils}>
                        <KeyboardDatePicker
                            disableToolbar
                            disabled={dateRangeType !== "custom"}
                            variant="inline"
                            format="MM/dd/yyyy"
                            margin="normal"
                            id="to-date-picker"
                            label=""
                            value={toDate}
                            onChange={handleToDateChange}
                            KeyboardButtonProps={{
                                "aria-label": "change date",
                            }}
                        />
                    </MuiPickersUtilsProvider>
                </Grid>
            </Grid>

        </>
    );
};

export default DatesSelector;
